module.exports = __webpack_public_path__ + "img/jrzq.3349c926.png";